import { Tabs, Tab } from '@mui/material';
import { StyledTabs } from './styles';
import { TabData } from 'utils/types';
import { useEffect } from 'react';

interface ITabsProps {
  tabs: TabData[];
  useSearchParams: any;
  isBottom?: boolean;
}

export const StoreTabs: React.FC<ITabsProps> = ({
  tabs,
  useSearchParams,
  isBottom = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currTab = searchParams.get('tab') || tabs[0].id;

  useEffect(() => {
    if (!searchParams.get('tab')) {
      setSearchParams({ tab: tabs[0].id });
    }
  }, [searchParams.get('tab')]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSearchParams({ tab: newValue });
  };

  return (
    <StyledTabs>
      <Tabs
        value={currTab}
        onChange={handleChange}
        variant="fullWidth"
        TabIndicatorProps={{
          style: {
            backgroundColor: '#ffffff',
            ...(isBottom ? { top: 0, bottom: 'auto' } : {}),
          },
        }}
        textColor="inherit"
      >
        {tabs.map(({ id, name, iconUrl }) => (
          <Tab
            key={id}
            value={id}
            label={iconUrl ? undefined : name}
            icon={
              iconUrl ? (
                <img
                  src={iconUrl}
                  style={{ width: 'auto', height: '25px' }}
                  alt="tab icon"
                />
              ) : undefined
            }
          />
        ))}
      </Tabs>
    </StyledTabs>
  );
};
